<div class="column">
  <div class="search-bar">
    <mat-form-field appearance="outline" class="status-search">
      <mat-label>Status</mat-label>
      <mat-select [(ngModel)]="queryStatus" (ngModelChange)="onFilter()">
        <mat-option value="">All</mat-option>
        <mat-option *ngFor="let s of statuses" [value]="s">{{s | titlecase}}</mat-option>
      </mat-select>
    </mat-form-field>
    <mat-form-field appearance="outline" class="search--input">
      <mat-label>Custom Search</mat-label>
      <mat-icon matPrefix class="search-hint-icon"
                matTooltip="Search receipts by full receipt number (e.g. 202607240001) or customer name. Type at least 3 characters."
                matTooltipPosition="above">info_outline</mat-icon>
      <input matInput type="text" placeholder="Custom Search" [(ngModel)]="query" (ngModelChange)="onQueryChange()">
      @if (query) {
      <button matSuffix mat-icon-button aria-label="close" (click)="clearSearch()">
        <mat-icon>close</mat-icon>
      </button>
      } @else {
      <button matSuffix mat-icon-button>
        <mat-icon>search</mat-icon>
      </button>
      }
    </mat-form-field>
  </div>
  <div class="mat-elevation-z8">
    <table mat-table class="full-width-table" [dataSource]="payments" aria-label="Receipts">
      <ng-container matColumnDef="receiptNumber">
        <th mat-header-cell *matHeaderCellDef>Receipt #</th>
        <td mat-cell *matCellDef="let row">{{row.receiptNumber}}</td>
      </ng-container>
      <ng-container matColumnDef="paymentDate">
        <th mat-header-cell *matHeaderCellDef>Date</th>
        <td mat-cell *matCellDef="let row">{{row.paymentDate | date:'MM/dd/yyyy h:mm a'}}</td>
      </ng-container>
      <ng-container matColumnDef="accountName">
        <th mat-header-cell *matHeaderCellDef>Customer</th>
        <td mat-cell *matCellDef="let row">{{row.accountName}}</td>
      </ng-container>
      <ng-container matColumnDef="totalPayment">
        <th mat-header-cell *matHeaderCellDef>Amount</th>
        <td mat-cell *matCellDef="let row">{{row.totalPayment | currency}}</td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let row">
          <app-status-indicator [statusText]="row.status | titlecase"></app-status-indicator>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="clickable"
        [routerLink]="['/app/cashering/', row.accountId, 'receipt', row.id]"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell" [attr.colspan]="displayedColumns.length">
          No data matching the filter.
        </td>
      </tr>
    </table>

    <mat-paginator [length]="totalElements" [pageIndex]="pageIndex" [pageSize]="pageSize"
      [pageSizeOptions]="[5, 10, 20]" (page)="onPage($event)" aria-label="Select page">
    </mat-paginator>
  </div>
</div>
